<template>
  <form action="">
    <b-card
      header="Datos Generales"
      header-tag="header"
      class="bold-header mt-3"
      header-bg-variant="gray_ligth"
    >
      <div class="form-row">
        <b-form-group
          id="input-group-3"
          label="DNI:"
          label-for="DNI"
          class=" col-md-6 mb-0"
        >
          <b-input class="p-2 px-4 btn-xs" v-model="usuario.dni" readonly>
          </b-input>
        </b-form-group>
        <b-form-group
          id="input-group-3"
          label="Apellidos:"
          label-for="input-2"
          class="col-md-6"
        >
          <b-input class="p-2 px-4 btn-xs" v-model="usuario.apellidos" readonly>
          </b-input>
        </b-form-group>

        <b-form-group
          id="input-group-3"
          label="Nombres"
          label-for="input-1"
          class="col-md-6"
        >
          <b-form-input
            id="nombres"
            v-model="usuario.nombres"
            readonly
            class="p-2 px-4 btn-xs"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-3"
          label="email"
          label-for="input-1"
          class="col-md-6"
        >
          <b-form-input
            id="email"
            v-model="usuario.email"
            readonly
            class="p-2 px-4 btn-xs"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-3"
          label="Telefono"
          label-for="input-1"
          class="col-md-6"
        >
          <b-form-input
            id="telefono"
            v-model="usuario.telefono"
            required
            readonly
            class="p-2 px-4 btn-xs"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-3"
          label="Estado"
          label-for="input-1"
          class="col-md-6"
        >
          <b-input class="p-2 px-4 btn-xs" v-model="usuario.estado" readonly>
          </b-input>
        </b-form-group>
        <b-form-group
          id="input-group-3"
          label="token"
          label-for="input-1"
          class="col-md-11"
        >
          <b-form-input
            id="uuid"
            v-model="usuario.uuid"
            readonly
            class="p-2 px-4 btn-xs"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-3"
          label="Cambiar"
          label-for="input-1"
          class="col-md-1"
        >
          <b-button
            type="button"
            @click="RenovarToken()"
            variant="info"
            class="p-2 px-4 btn-xs"
            >Renovar</b-button
          >
        </b-form-group>
      </div>
    </b-card>
  </form>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      id_usuario: "",
      isLoading: false,
      EstadoNombre: null,
      EstadoNroDocumento: null,
      EstadoTipoDocumento: null,
      EstadoBoton: false,
      estados: [
        { estado: "V", descripcion: "Vigente" },
        { estado: "A", descripcion: "Anulado" },
      ],
      usuario: {
        nombres: "",
        apellidos: "",
        email: "",
        dni: "",
        uuid: "",
        telefono: "",
        estado: "",
        verificado: "",
        verifcadocod: "",
        tipo: "",
      },
    };
  },
  watch: {},
  created() {},
  computed: {},
  mounted() {
    this.CargarSesion().then(this.CargarDatos());
    //this.id_usuario = this.$store.state.id_usuario;
  },
  methods: {
    async CargarSesion() {
      this.id_usuario = await this.$store.dispatch("getidUsuario");
    },
    CargarDatos() {
      var me = this;
      axios({
        method: "post",
        url: "ApiWeb/UsuarioId.php",
        data: { id_usuario: (this.id_usuario = this.$store.state.id_usuario) },
      })
        .then((response) => {
          me.usuario.nombres = response.data.data.nombres;
          me.usuario.apellidos = response.data.data.apellidos;
          me.usuario.email = response.data.data.email;
          me.usuario.dni = response.data.data.dni;
          me.usuario.uuid = response.data.data.uuid;
          me.usuario.telefono = response.data.data.telefono;
          me.usuario.estado = response.data.data.estado;
        })
        .catch(function(error) {
          //console.log(error);
        });
    },
    RenovarToken() {
      var me = this;
      axios({
        method: "post",
        url: "ApiWeb/GenerarToken.php",
        data: { id_usuario: me.$store.state.id_usuario },
      })
        .then((response) => {
          me.usuario.uuid = response.data.token;
        })
        .catch(function(error) {
          //console.log(error);
        });
    },
    makeToast(msg, color) {
      this.toastCount++;
      this.$bvToast.toast(msg, {
        title: "Mensaje Cliente",
        variant: color,
        autoHideDelay: 3000,
        appendToast: false,
      });
    },
  },
};
</script>
<style scoped>
::v-deep .myDiv {
  background-color: #ffffff;
}
.bold-header {
  font-weight: bold; /* Aplica negrita al encabezado */
}
.form-label {
  margin-top: 5px;
  color: rgb(9, 40, 126);
  margin-bottom: 5px;
  &:first-of-type {
    margin-top: 0rem;
  }
}
</style>
